import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => {}, colors: {} });

const darkColors = {
  bg: '#050505', bgCard: 'rgba(255,255,255,0.04)', bgHover: 'rgba(255,255,255,0.06)',
  purple: '#8B5CF6', cyan: '#22D3EE', gold: '#FBBF24', green: '#10B981', red: '#EF4444',
  text: '#F8FAFC', text2: '#94A3B8', muted: '#64748B',
  border: 'rgba(255,255,255,0.07)', glass: 'rgba(255,255,255,0.04)',
  navBg: 'rgba(5,5,5,0.8)', navBorder: 'rgba(255,255,255,0.04)',
  inputBg: 'rgba(255,255,255,0.06)',
};

const lightColors = {
  bg: '#F8FAFC', bgCard: 'rgba(0,0,0,0.02)', bgHover: 'rgba(0,0,0,0.04)',
  purple: '#7C3AED', cyan: '#0891B2', gold: '#D97706', green: '#059669', red: '#DC2626',
  text: '#0F172A', text2: '#475569', muted: '#94A3B8',
  border: 'rgba(0,0,0,0.08)', glass: 'rgba(0,0,0,0.02)',
  navBg: 'rgba(248,250,252,0.85)', navBorder: 'rgba(0,0,0,0.06)',
  inputBg: 'rgba(0,0,0,0.04)',
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem('pd-theme') || 'dark');

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    localStorage.setItem('pd-theme', next);
    document.documentElement.setAttribute('data-theme', next);
  };

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const colors = theme === 'dark' ? darkColors : lightColors;

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
